const C = {
  name: "Notification",
  dimensions: { width: 20, height: 22 },
  content: `
    <g>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.99989 0C8.19413 0 6.66915 1.19577 6.17131 2.83879C4.01637 3.91346 2.39223 5.93928 1.89387 8.43107L0.497754 15.4117C0.126479 17.268 1.54636 19 3.4395 19H6.12583C6.56988 20.7252 8.13598 22 9.99982 22C11.8637 22 13.4298 20.7252 13.8738 19H16.5603C18.4534 19 19.8733 17.268 19.502 15.4117L18.1059 8.43107C17.6075 5.93928 15.9834 3.91346 13.8285 2.83879C13.3306 1.19577 11.8056 0 9.99989 0ZM8.02304 3.6938C8.16975 2.73484 8.99992 2 9.99989 2C10.9999 2 11.83 2.73484 11.9767 3.6938C12.0294 4.03809 12.2574 4.33018 12.5786 4.46482C14.3735 5.21718 15.7441 6.82025 16.1447 8.8233L17.5409 15.8039C17.6646 16.4227 17.1913 17 16.5603 17H3.4395C2.80845 17 2.33516 16.4227 2.45892 15.8039L3.85503 8.8233C4.25564 6.82025 5.62632 5.21718 7.42113 4.46482C7.74235 4.33018 7.97037 4.03809 8.02304 3.6938ZM11.7323 19H8.26738C8.61319 19.5978 9.25953 20 9.99982 20C10.7401 20 11.3864 19.5978 11.7323 19Z" fill="currentColor"/>
    </g>
    `
};
export {
  C as Notification
};
